import { AbstractControl, ValidatorFn } from '@angular/forms';

export function prefixValidator(prefix: any): ValidatorFn {
    return (control: AbstractControl): { [key: string]: any } | null => {
        const value = control.value?.toString();
        if (!value || !value.startsWith(prefix.toString())) {
            return { startsWith: `The value must start with ${prefix}.` };
        }
        return null;
    };
}
